import { render, staticRenderFns } from "./ChooseProduct.vue?vue&type=template&id=0ab3d978&scoped=true"
import script from "./ChooseProduct.vue?vue&type=script&lang=js"
export * from "./ChooseProduct.vue?vue&type=script&lang=js"
import style0 from "./ChooseProduct.vue?vue&type=style&index=0&id=0ab3d978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab3d978",
  null
  
)

export default component.exports